import React, { useState } from 'react';
import API_BASE_URL from "../../apiConfig";

const OpenNewTicket = () => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Handle form submission logic, e.g., calling the API to create the ticket
    const ticketData = {
      subject,
      message,
    };

    // Call your API endpoint here (example)   fetch(''
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await fetch(`${API_BASE_URL}/RiseTicket/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(ticketData),
      });
      const data = await response.json();
      if (response.ok) {
        alert('Ticket created successfully!');
      } else {
        alert(data.message || 'Failed to create ticket');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error creating ticket');
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <form onSubmit={handleSubmit}>
              <div className="card card-default">
                <div className="card-header">
                  <h2>Individual</h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-3">
                      <label htmlFor="Subject">Subject</label>
                    </div>
                    <div className="form-group col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        id="Subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="Message">Message</label>
                    </div>
                    <div className="form-group col-md-9">
                      <textarea
                        id="Message"
                        placeholder="Message"
                        className="form-control"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="form-footer pt-5">
                    <button type="submit" className="btn btn-primary btn-pill">Create Ticket</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default OpenNewTicket;



// import React from 'react';

// const OpenNewTicket = () => {
//   return (
//    <>
//         <div className="container">
//         <div className="row">
//           <div className="col-xl-12">
//             <form>
//               <div className="card card-default">
//                 <div className="card-header">
//                   <h2>Individual</h2>
//                 </div>
//                 <div className="card-body">
//                   <div className="row">
//                     <div className="form-group col-md-3">
//                         <label htmlFor="AreaCode">Subject</label>
//                     </div>
//                     <div className="form-group col-md-9">
//                        <input type="text" className="form-control" id="Subject"/>
//                     </div>
//                     <div className="form-group col-md-3">
//                         <label htmlFor="AoType">Message </label>
//                     </div>
//                     <div className="form-group col-md-9">
//                         <textarea placeholder="Message" className="form-control" />
//                     </div>
//                   </div>
//                   <div className="form-footer pt-5">
//                     <button type="submit" className="btn btn-primary btn-pill">Create Ticket</button>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//    </>
//   );
// };

// export default OpenNewTicket;

